import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CoreThemingService } from '@ui-core/services/core-theming.service';
import { IHeaderModel } from '@types-custom/models/ui/header.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import {
  IndicatorApiModel,
  IndicatorModel,
  IndicatorProps,
} from '@types-custom/models/ui/indicators.model';
import {
  BehaviorSubject,
  interval,
  map,
  mergeMap,
  startWith,
  tap,
  // map,
  // mergeMap,
  // Observable,
  // startWith,
} from 'rxjs';
import { ActionType, IMenuEvent } from "@types-custom/models/ui/menu.model";
import { ActionService } from "@shared/services/action-service/action.service";
import { NotificationService } from '@shared/services/notifications-service/notification.service';
// import { AnyAaaaRecord } from 'dns';

/*
 ** Header
 ** Render a header section
 */

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() properties: IHeaderModel<any> = {};
  @Input() visibleSideMenu: boolean | undefined = undefined;
  @Output() flagSideMenu: EventEmitter<any> = new EventEmitter();
  @Input() indicators = new BehaviorSubject<IndicatorModel[] | undefined>(
    undefined
  );
  @Input() indicatorProps: IndicatorProps;
  theme$ = this.coreThemingService.theme$;
  Icon = Icon;
  hourBoard = '';
  dateBoard = '';
  refreshIndicators = interval(500000);

  statefulComponentsState: { [key: string]: boolean } = {};

  notificationsAmount = 0;

  constructor(
    private coreThemingService: CoreThemingService,
    private actionService: ActionService,
    private notificationService: NotificationService
  ) {
    // TODO: Improve approach, is causing performance issues
    // setInterval(() => this.dateOnBoard(), 1000); //TODO: to improve performance use this just if needed
  }
  ngOnInit(): void {
    this.notificationService.getNotificationStatus();
    this.setIndicators();
    this.setNotificationsBadge();

  }

  get notificationsAmountFormatted() {
    if (this.notificationsAmount >= 1000000) {
      return (this.notificationsAmount / 1000000).toFixed(1) + 'M';
    } else if (this.notificationsAmount >= 1000) {
      return (this.notificationsAmount / 1000).toFixed(1) + 'K';
    } else {
      return this.notificationsAmount.toString();
    }

  }

  setNotificationsBadge() {
    this.notificationService.notificationStatus.subscribe((e: any) => {
      this.notificationsAmount = e?.notificationAmount ?? 0;
    });
  }

  setIndicators() {
    this.refreshIndicators
      .pipe(
        startWith(-1),
        mergeMap(() => this.indicatorProps.indicatorDataSource.getIndicators()),
        map((response: any) => {
          const roundedResponse: any = {};
          for (const key in response) {
            if (typeof response[key] === 'number') {
              roundedResponse[key] = parseFloat(response[key].toFixed(1));
            } else {
              roundedResponse[key] = response[key];
            }
          }

          return roundedResponse;
        })
      )
      .subscribe((e: IndicatorApiModel) =>
        this.indicators.next(this.indicatorProps.generateIndicatorsModel(e))
      );
  }

  toggleSideMenu() {
    this.visibleSideMenu = !this.visibleSideMenu;
    this.flagSideMenu.emit(this.visibleSideMenu);
  }

  dateOnBoard() {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'Europe/Madrid', // Zona horaria para España peninsular
    };
    this.hourBoard = date.toLocaleString('en-US', options);
    const optionsDate: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      timeZone: 'Europe/Madrid', // Zona horaria para España peninsular
    };
    this.dateBoard = date.toLocaleString('es-ES', optionsDate);
  }

  toggleStatefulMenu(identifier: string, state?: boolean) {
    if (state !== undefined) {
      this.statefulComponentsState[identifier] = state;
      return;
    }
    this.statefulComponentsState[identifier] = !(this.statefulComponentsState[identifier] ?? false);
  }
}
